export default {
    setFirstName: (state, firstName) => state.firstName = firstName,
    setLastName: (state, lastName) => state.lastName = lastName,
    setAccountNumber: (state, accountNumber) => state.accountNumber = accountNumber,
    setSortCode: (state, sortCode) => state.sortCode = sortCode,
    setPaymentMethodId: (state, paymentMethodId) => state.paymentMethodId = paymentMethodId,
}
